export default "__VITE_ASSET__XpaaYR$e__"